import { render, staticRenderFns } from "./OnboardingValidation.vue?vue&type=template&id=35b64e97&"
import script from "./OnboardingValidation.vue?vue&type=script&lang=js&"
export * from "./OnboardingValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports